export enum ChecklistEnum {
  BLK_CHECK_EXM = "BLK_CHECK_EXM",
  BLK_CHECK_DG = "BLK_CHECK_DG",
  BLK_RET_CHECK_EXM = "BLK_RET_CHECK_EXM",
  BLK_RET_CHECK_DG = "BLK_RET_CHECK_DG",
  BLK_REV_CHECK_EXM = "BLK_REV_CHECK_EXM",
  BLK_REV_CHECK_DG = "BLK_REV_CHECK_DG",
  BLK_REV_RET_CHECK_EXM = "BLK_REV_RET_CHECK_EXM",
  BLK_REV_RET_CHECK_DG = "BLK_REV_RET_CHECK_DG",
  APPROVAL_SHO = "APPROVAL_SHO",
  APPROVAL_EXM = "APPROVAL_EXM",
  APPROVAL_DG = "APPROVAL_DG",
  SUS_CHECK_EXM = "SUS_CHECK_EXM",
  SUS_CHECK_DG = "SUS_CHECK_DG",
  SUS_RET_CHECK_EXM = "SUS_RET_CHECK_EXM",
  SUS_RET_CHECK_DG = "SUS_RET_CHECK_DG",
  SUS_REV_CHECK_EXM = "SUS_REV_CHECK_EXM",
  SUS_REV_CHECK_DG = "SUS_REV_CHECK_DG",
  SUS_REV_CHECK_SHO = "SUS_REV_CHECK_SHO",
  SUS_REV_RET_CHECK_SHO = "SUS_REV_RET_CHECK_SHO",
  SUS_REV_RET_CHECK_EXM = "SUS_REV_RET_CHECK_EXM",
  SUS_REV_RET_CHECK_DG = "SUS_REV_RET_CHECK_DG",
  SUS_BLK_CHECK_EXM = "SUS_BLK_CHECK_EXM",
  SUS_BLK_CHECK_DG = "SUS_BLK_CHECK_DG",
  SUS_BLK_RET_CHECK_EXM = "SUS_BLK_RET_CHECK_EXM",
  SUS_BLK_RET_CHECK_DG = "SUS_BLK_RET_CHECK_DG",
  SUS_BLK_REV_CHECK_EXM = "SUS_BLK_REV_CHECK_EXM",
  SUS_BLK_REV_CHECK_DG = "SUS_BLK_REV_CHECK_DG",
  SUS_BLK_REV_RET_CHECK_SHO = "SUS_BLK_REV_RET_CHECK_SHO",
  SUS_BLK_REV_RET_CHECK_EXM = "SUS_BLK_REV_RET_CHECK_EXM",
  SUS_BLK_REV_RET_CHECK_DG = "SUS_BLK_REV_RET_CHECK_DG",
  RETURN_SHO = "RETURN_SHO",
  RETURN_EXM = "RETURN_EXM",
  RETURN_DG = "RETURN_DG",
  REJECT_SHO = "REJECT_SHO",
  REJECT_EXM = "REJECT_EXM",
  REJECT_DG = "REJECT_DG",

}
